
import { defineComponent, onMounted, reactive, toRefs } from "vue";
import Header from "@/components/Header.vue";
import Bottom from "@/components/Bottom.vue";
import AboutUs from "@/components/AboutUs.vue";
import { selArticleList } from "@/api";
import { useRoute } from "vue-router";
export default defineComponent({
  name: "aboutUs",
  components: {
    Header,
    Bottom,
    AboutUs
  },
  setup() {
    const route = useRoute();
    const data = reactive({
      companyProfile: {},
      connectUs: {}
    });
    const getCompanyProfile = async () => {
      const params = { menu_id: route.query.id };
      await selArticleList(params).then((res: any) => {
        console.log(res);
        res.data.filter((val: any) => {
          if (val.url == "company-profile") {
            data.companyProfile = val;
          } else if (val.url == "connect") {
            data.connectUs = val;
          }
        });
      });
    };
    onMounted(() => {
      getCompanyProfile();
    });
    return {
      ...toRefs(data)
    };
  }
});
